export default __webpack_public_path__ + "goldenhour.mp3";